import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, useLocation } from "react-router-dom";
import { SurveyProvider } from "@/contexts/SurveyContext";
import { AuthProvider } from "@/contexts/AuthContext";
import { PlausibleProvider } from "@/contexts/PlausibleContext";
import AppRoutes from "./AppRoutes";
import { HelmetProvider } from 'react-helmet-async';
import DomainGuard from "@/components/layout/DomainGuard";
import { AppErrorBoundary } from "@/components/layout/AppErrorBoundary";

const queryClient = new QueryClient();

const ResettableBoundary: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  return (
    <AppErrorBoundary key={location.pathname}>
      {children}
    </AppErrorBoundary>
  );
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <AuthProvider>
        <SurveyProvider>
          <PlausibleProvider>
            <HelmetProvider>
              <DomainGuard />
              <Toaster />
              <Sonner />
              <BrowserRouter>
                <ResettableBoundary>
                  <AppRoutes />
                </ResettableBoundary>
              </BrowserRouter>
            </HelmetProvider>
          </PlausibleProvider>
        </SurveyProvider>
      </AuthProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
